import React from "react";
/* eslint-disable-next-line import/no-extraneous-dependencies */
import "@dotlottie/player-component";
import { useThemeTokens } from "../../hooks/useThemeTokens";

interface Props {
  sx?: any
  fill?: boolean
};

// The animation paints three colors: gold (#B1802C), near-black (#3F433E) and a
// third shape that reads as the "cut out" where the two circles overlap. That
// shape was authored WHITE, which only works on a white page — on the dark
// canvas it became a bright disc.
//
// A Lottie cannot be recolored per-shape from CSS, so the artwork itself is
// shipped in two variants (public/loader-light.json, public/loader-dark.json,
// generated from the original). The dark one repaints that overlap shape with
// --page, so gold and black stay as authored and the overlap reads as the page
// behind them.
export function DotLottleLoader( { sx, fill=true }:Props ) {
  const { mode } = useThemeTokens();
  let style = { width: 500, height: 500 };
  if( sx ) {
    style = { ...style, ...sx };
  }
  let className = "flex items-center justify-center";
  if( fill ) {
    className += " w-full h-full";
  }
  const src = `${process.env.PUBLIC_URL || ""}/loader-${mode === "dark" ? "dark" : "light"}.json`;
  return (
    <div className={ className }>
      {/* @ts-ignore */}
      <dotlottie-player
        key={ src }
        src={ src }
        autoplay
        speed={1}
        background="transparent"
        loop
        style={ style }
      />
    </div>
  );
}
